// extracted by mini-css-extract-plugin
export var boxItems = "_bp-1";
export var boxItemsLg = "_bp-2";
export var button = "_bp-7";
export var buttonLg = "_bp-8";
export var filterGroupBox = "_bp-0";
export var icon = "_bp-3";
export var iconSecondary = "_bp-6";
export var iconWrapper = "_bp-4";
export var iconWrapperLg = "_bp-5";